<template>
  <select v-model="selected_province" class="custom-select">
    <option value="" v-t="`province.province_picker`"></option>
    <option v-for="province in provinces" :value="province.id">{{ province.name }}
    </option>
  </select>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ProvincePicker1",
  props: {
    province: {
      default: ''
    },
  },
  data() {
    return {
      selected_province: ''
    }
  },
  computed: {
    ...mapGetters({
      provinces: 'Province/getProvinces'
    })
  },
  mounted() {
    this.$store.dispatch('Province/setProvinces')
  },
  watch: {
    selected_province: {
      handler: async function (newValue, oldValue) {
        if (newValue != null) {
          await this.$emit('update:modelValue', this.selected_province)
        }
      },
      deep: true
    },
    province: {
      handler: async function (newValue, oldValue) {
        if (newValue != '') {
          this.selected_province = this.province
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>

</style>